const backendUrlBuilder = (...routeParts) => {
  const routes = routeParts.filter((item) => item);
  return process.env.REACT_APP_BACKEND + '/' + routes.join('/');
};

export default backendUrlBuilder;
